import { render, staticRenderFns } from "./ProductImageSelector.vue?vue&type=template&id=de19e528&scoped=true&"
import script from "./ProductImageSelector.vue?vue&type=script&lang=js&"
export * from "./ProductImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de19e528",
  null
  
)

export default component.exports